// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"0c8e55dd","297":"5f90e106","643":"d7f8fc0a"}[chunkId] + ".chunk.js";
};